export default __webpack_public_path__ + "static/media/Resource Tracking.9da2dc8d.png";